var React = require('react');

function Z (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.8066 32.9999V27.5549H23.4766C23.4766 32.3069 11.8936 32.6699 8.75864 32.6699H4.03961L24.6976 -6.10352e-05H1.79562V4.45494H2.12561V4.32294C2.12561 2.11194 6.21762 0.329937 11.8936 0.329937H21.2986L0.640625 32.9999H23.8066Z","fill":"currentColor"}));
}

Z.defaultProps = {"width":"25","height":"33","viewBox":"0 0 25 33","fill":"none"};

module.exports = Z;

Z.default = Z;
